import {createBrowserHistory} from 'history';
import {compose as _compose, createStore, applyMiddleware} from 'redux';
import {routerMiddleware} from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';
import axios from 'axios';
import {handleRequests} from '@redux-requests/core';
import {createDriver} from '@redux-requests/axios';
import saga from './saga';
import createReducer from './reducer';
import api, {API_URL, onRequest, onError, onSuccess} from 'api';
import {createSessionBoundary, purgeLegacyResponses} from 'api/session';
import {persistStore, persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const compose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _compose;

export const history = createBrowserHistory({basename: process.env.PUBLIC_URL});

const sagaMiddleware = createSagaMiddleware();

const persistConfig = {
  key: 'cdo',
  storage,
  whitelist: ['token'],
  migrate: state => Promise.resolve(state ? {token: state.token, _persist: state._persist} : state),
};

const configureStore = () => {
  const actionTypes = Object.values(api).map(action => action.toString());
  purgeLegacyResponses(actionTypes);
  const session = createSessionBoundary(actionTypes);
  const {requestsReducer, requestsMiddleware} = handleRequests({
    driver: session.wrapDriver(
      createDriver(
        axios.create({
          baseURL: API_URL,
          headers: {'Content-Type': 'application/json'},
        }),
      ),
    ),
    onRequest,
    onError: session.guard(onError),
    onSuccess: session.guard(onSuccess),
  });

  const persistedReducer = persistReducer(
    persistConfig,
    createReducer(history, {requests: requestsReducer}),
  );

  const store = createStore(
    persistedReducer,
    compose(
      applyMiddleware(
        session.middleware,
        routerMiddleware(history),
        sagaMiddleware,
        ...requestsMiddleware,
      ),
    ),
  );

  const persistor = persistStore(store);

  sagaMiddleware.run(saga);

  return {store, persistor};
};

export default configureStore();
